import { vehicleOutlinePlaceholders } from "./vehicleOutlinePlaceholders";

// gambar_depan/kiri/kanan/belakang -> "depan"/"kiri"/"kanan"/"belakang"
const sideOf = (field) => field.replace(/^gambar_(box_)?/, "");

// The reference model a marking is placed on: the uploaded jenis_mobil photo of the vehicle (gambar_*) or of the
// trailer (gambar_box_*) for that side, or the generic outline when the jenis has none.
export const getMarkingReferenceImage = ({ headerData, field }) => {
  const isBox = field.startsWith("gambar_box_");
  const jenisSource = isBox ? headerData.data_trailer : headerData.data_kendaraan;

  const jenis = jenisSource?.data_jenis_mobils?.[0];
  const referencePhoto = jenis?.[`gambar_${sideOf(field)}`];

  return referencePhoto || vehicleOutlinePlaceholders[field] || "";
};
